import { Bars, LoaderProvider } from "@agney/react-loading"
import React from "react"
import Loader from "../Loader"

function LoadingComp({ customStyle }) {
  return (
    <div style={{ textAlign: "center", height: "70vh", ...customStyle }}>
      <LoaderProvider indicator={<Bars width="50" />}>
        <Loader />
      </LoaderProvider>
    </div>
  )
}

export default LoadingComp
